import { useToastStore } from "@/state/toast.store";

/** Renders the stack of active toasts (fixed, bottom-right). Mount once, app-wide. */
export function Toaster() {
  const toasts = useToastStore((s) => s.toasts);
  const dismiss = useToastStore((s) => s.dismiss);
  if (toasts.length === 0) return null;
  return (
    <div className="toaster" role="status" aria-live="polite">
      {toasts.map((t) => (
        <button key={t.id} className={`toast toast--${t.tone}`} onClick={() => dismiss(t.id)} type="button">
          {t.message}
        </button>
      ))}
    </div>
  );
}
